import Cookies from "js-cookie";
import { decompressFromEncodedURIComponent as decompress } from "lz-string";
import { COOKIE_NAME, getAppId } from "./config";
import { deleteCookies } from "./shared";
export function restoreGladlySession() {
    try {
        const payload = Cookies.get(COOKIE_NAME);
        if (payload) {
            try {
                const decoded = decompress(payload);
                localStorage.setItem(getAppId(), decoded);
                deleteCookies(COOKIE_NAME);
            }
            catch (e) {
                console.warn("Failed to restore chat session", e);
            }
        }
    }
    catch (e) {
        console.warn("Failed to restore chat session", e);
    }
}
